// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-select.select {
  margin: 0px;
}

.row {
  align-items: center;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

.red {
  color: #d3001d;
}

.globalLimit {
  padding-bottom: 10px;
}

.timeDelete, .timeRolloverPeriod, .timeRemoved, .timeAmountUsed, .timeNewLimitEffective, .timePendingLimitEffective {
  display: none;
}

.button-row {
  justify-content: center;
  display: grid;
}

.deposit-column {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label-colum {
  display: flex;
  align-items: center;
}

.label-text {
  text-overflow: "-";
  white-space: nowrap;
}

.deposit-column {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

hr {
  border: 0;
  height: 1px;
  background: #C2C2C2;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/limits/set-time-limits/set-time-limits.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;;AAGI;EACI,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAAR;;AAGI;EACI,cAAA;AAAR;;AAGI;EACI,oBAAA;AAAR;;AAGI;EACI,aAAA;AAAR;;AAGI;EACI,uBAAA;EACA,aAAA;AAAR;;AAII;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADR;;AAII;EACI,aAAA;EACA,mBAAA;AADR;;AAII;EACI,kBAAA;EACA,mBAAA;AADR;;AAII;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADR;;AAII;EACI,SAAA;EACA,WAAA;EACA,mBAAA;AADR","sourcesContent":["\r\n    ion-select.select {\r\n        margin: 0px;\r\n    }\r\n    \r\n    .row {\r\n        align-items: center;\r\n        white-space: nowrap;\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n    .red {\r\n        color: #d3001d;\r\n    }\r\n\r\n    .globalLimit {\r\n        padding-bottom: 10px;\r\n    }\r\n\r\n    .timeDelete, .timeRolloverPeriod, .timeRemoved, .timeAmountUsed, .timeNewLimitEffective, .timePendingLimitEffective {\r\n        display: none;\r\n    }\r\n\r\n    .button-row {\r\n        justify-content: center;\r\n        display: grid;\r\n        \r\n    }\r\n\r\n    .deposit-column {\r\n        flex-direction: row;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n\r\n    .label-colum {\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n    .label-text {\r\n        text-overflow: \"-\";\r\n        white-space: nowrap;\r\n    }\r\n\r\n    .deposit-column {\r\n        flex-direction: row;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n\r\n    hr {\r\n        border: 0;\r\n        height: 1px;\r\n        background: #C2C2C2;\r\n    }\r\n\r\n    // ion-select::part(icon) {\r\n    //     color: var(--ion-color-primary);\r\n    // }\r\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
